<template>
    <article class="tile is-child t-box">
        <p class="title">Setup</p>
        <p class="subtitle">Gear and accessories</p>
        <div class="content">
        <div class="setup-holder">
            <div class="category">
              <div class="category-title">PC</div>
              <div 
                v-for="item in pc"
                :key="item.id"
                class="category-item"
              >
                <div class="category-name">{{ item.type }}</div>
                <div class="category-user">{{ item.input }}</div>
              </div>
            </div>
            <div class="category">
              <div class="category-title">Peripherals</div>
              <div class="category-item">
                  <div class="category-name">Mouse</div>
                  <div class="category-user">Logitech G Pro Wireless</div>
              </div>
              <div class="category-item">
                  <div class="category-name">KB</div>
                  <div class="category-user">Fnatic Strafe</div>
              </div>
              <div class="category-item">
                  <div class="category-name">MPAD</div>
                  <div class="category-user">Nadeking Mousepad</div>
              </div>
              <div class="category-item">
                  <div class="category-name">Mic</div>
                  <div class="category-user">Shure SM7B Microphone + Cloudlifter + Scarlett Focusrite 2i2</div>
              </div>
              <div class="category-item">
                  <div class="category-name">Mic arm</div>
                  <div class="category-user">Rode PSA1</div>
              </div>
            </div>
            <div class="category">
              <div class="category-title">Monitors</div>
                <div class="category-item">
                  <div class="category-name">Main</div>
                  <div class="category-user">MSI Oculux NXG251R</div>
              </div>
              <div class="category-item">
                  <div class="category-name">Left</div>
                  <div class="category-user">Medion 24"</div>
              </div>
              <div class="category-item">
                  <div class="category-name">Right</div>
                  <div class="category-user">iiyama 24"</div>
              </div>
            </div>
        </div>
        </div>
    </article>    
</template>

<script>
export default {
  data () {
    return {
      pc: {
        0: {
          type: 'Case',
          input: 'Corsair Carbide Clear 600C'
        },
        1: {
          type: 'MOBO',
          input: 'MSI Z270 GAMING M6 AC'
        },
        2: {
          type: 'GPU',
          input: 'EVGA GeForce GTX 1080 Ti SC2 GAMING'
        },
        3: {
          type: 'CPU',
          input: 'Intel Core i7 7700K'
        },
        4: {
          type: 'SSD',
          input: 'Crucial MX300'
        },
        5: {
          type: 'HDD',
          input: 'Toshiba MD04ACA400'
        },
        6: {
          type: 'PSU',
          input: 'LEPA MaxBron Series B800-MB'
        },
        7: {
          type: 'Cooler',
          input: 'Corsair Hydro Series H90'
        },
        8: {
          type: 'RAM',
          input: 'Kingston HyperX FURY (2x 16GB)'
        },
        9: {
          type: 'OS',
          input: 'Windows 10'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setup-holder {
  display: flex;
  flex-direction: column;
  .category {
    margin-bottom: 15px;
    .category-title {
      padding: 0.45em 1em;
      background: #1f1f1f;
      border-bottom: 2px solid #151515;
      font-size: 1em;
      font-weight: 600;
    }
    .category-item {
      display: flex;
      font-size: 0.80em;
      letter-spacing: 0.5px;
      border-bottom: 2px solid #151515;
      background: #1f1f1f;
      &:hover {
        background: #151515;
      }
        &:nth-child(even) {
          background: #272727;
          &:hover {
            background: #151515;
          }
        }
      .category-name {
        padding: 0.25em 1em;
        border-right: 2px solid #151515;
        font-weight: 600;
        text-align: center;
        width: 75px;
      }
      .category-user {
        padding: 0.25em 1em;
        width: 100%;
        font-weight: 600;
        color: #929292;
      }
    }
  }
}
</style>
